import { render, staticRenderFns } from "./MastHead.vue?vue&type=template&id=55328b1c"
import script from "./MastHead.vue?vue&type=script&lang=js"
export * from "./MastHead.vue?vue&type=script&lang=js"
import style0 from "./MastHead.vue?vue&type=style&index=0&id=55328b1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports